module.exports = __webpack_public_path__ + "img/car_00069.ae8f7f79.jpg";